'use strict';

module.exports = require('nmr-predictor');



// WEBPACK FOOTER //
// ./index.js